import { useInitPaddle } from "./initPaddle";

export default function PaddleInitializer() {
  useInitPaddle();
  return null; // no UI
}
